import { PlatformAtom } from '@/store/platform';
import { useRecoilState } from 'recoil';

export const usePlatform = () => {
  const [{ currentOs, isMobile }, setPlatformState] = useRecoilState(PlatformAtom);

  const handleSetIsMobile = (changedIsMobile: boolean) => {
    setPlatformState(prevState => ({ ...prevState, isMobile: changedIsMobile }));
  };

  const isMac = currentOs.includes('MAC');

  return { currentOs, isMobile, setIsMobile: handleSetIsMobile, isMac };
};
